import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import LcvOrderImport from "./views/LcvOrderImport";
import LcvOrderImportResults from "./views/LcvOrderImportResults";

import { lcvOrdersClearImport } from "../../../../_redux/_actions/lcvOrders.action";

// The Commandes workbook is read by the backend, twice: once to show what would happen and once to
// store it. Nothing is written until the administrator commits.
export default function LcvOrderUploadWrapper() {
     const actionDispatch = useDispatch();

     const importResult = useSelector((state) => state?.lcvOrders?.importResult);

     useEffect(() => {
          return () => {
               actionDispatch(lcvOrdersClearImport());
          };
     }, [actionDispatch]);

     const done = useCallback(() => {
          actionDispatch(lcvOrdersClearImport());
     }, [actionDispatch]);

     return (
          <>
               <MainLeftTitle title="LCV Order Upload" />

               <div className="sba-telerik-components-wr">
                    {/* Either the file being checked or the outcome is on screen, never both. */}
                    {importResult ? (
                         <LcvOrderImportResults result={importResult} onDone={done} />
                    ) : (
                         <LcvOrderImport />
                    )}
               </div>
          </>
     );
}
